import { render, staticRenderFns } from "./PageContentOrphanedItem.vue?vue&type=template&id=0e8db065&scoped=true"
import script from "./PageContentOrphanedItem.vue?vue&type=script&lang=js"
export * from "./PageContentOrphanedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8db065",
  null
  
)

export default component.exports